// sans manoeuvre + sans dimensions

import formInputsTypes from '../simulatorConstant';
import Acier from 'assets/img/acier.png';
import Nylon from 'assets/img/nylon.png';
import Haut from 'assets/img/galet-haut.png';
import Bas from 'assets/img/galet-haut.png';
import Milieu from 'assets/img/galet-haut.png';

const galetNombre = {
	id: 'PG-GAL-NB',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'galetNombre',
	className: 'col-6',
	label: 'Nombre de galets à remplacer',
	placeholder: '0',
	defaultValue: 1,
	nextStep: false, // next summary / devis
	validation: (v) => v > 0,
};
export const galetPosition = {
	id: 'PG-GAL-POS',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'galetPosition',
	className: 'col-12',
	label: 'Position des galets concernés',
	nextStepData: galetNombre,
	options: [
		{
			id: 'PG-GAL-POS-H',
			label: 'Haut',
			value: 'Haut',
			// imageUrl: Haut,
			description:
				'Galets situés dans la partie supérieure de la porte, assurant le guidage en fin d’ouverture.',
		},
		{
			id: 'PG-GAL-POS-M',
			label: 'Milieu',
			value: 'Milieu',
			// imageUrl: Milieu,

			description:
				'Galets positionnés sur les panneaux intermédiaires, contribuant à la stabilité et au bon alignement de la porte.',
		},
		{
			id: 'PG-GAL-POS-B',
			label: 'Bas',
			// imageUrl: Bas,
			value: 'Bas',
			description:
				'Galets situés dans la partie basse de la porte, fortement sollicités lors des manœuvres.',
		},
	],
};

export const galetType = {
	id: 'PG-GAL-TYPE',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'galetType',
	className: 'col-12',
	label: 'Type de galet',
	nextStepData: galetPosition,
	options: [
		{
			id: 'PG-GAL-TYPE-NYL',
			label: 'Nylon',
			value: 'Nylon',
			imageUrl: Nylon,

			description:
				'Galet en nylon conçu pour réduire les bruits de fonctionnement et assurer un déplacement fluide dans les rails.',
		},
		{
			id: 'PG-GAL-TYPE-ACI',
			label: 'Acier',
			value: 'Acier',
			imageUrl: Acier,
			description:
				'Galet en acier offrant une résistance accrue, adapté aux portes lourdes ou à usage intensif.',
		},
		{
			id: 'PG-GAL-TYPE-AUT',
			label: 'Autre',
			value: 'Autre',
		},
	],
};
